const logOut = () => {
  window.localStorage.clear();
  window.location.replace("/login");
};
export default logOut;
